import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["issueDate", "preset", "customField", "dueDate"]

  connect() {
    this.updateCustomField()
  }

  presetChanged() {
    if (this.presetTarget.value !== "custom") this.applyPreset()
    this.updateCustomField()
  }

  issueDateChanged() {
    if (this.presetTarget.value !== "custom") this.applyPreset()
  }

  customDateChanged() {
    this.presetTarget.value = "custom"
    this.updateCustomField()
  }

  applyPreset() {
    if (!this.issueDateTarget.value) return

    const date = this.parseDate(this.issueDateTarget.value)
    date.setUTCDate(date.getUTCDate() + Number.parseInt(this.presetTarget.value, 10))
    this.dueDateTarget.value = this.formatDate(date)
  }

  updateCustomField() {
    this.customFieldTarget.classList.toggle("hidden", this.presetTarget.value !== "custom")
  }

  parseDate(value) {
    const [year, month, day] = value.split("-").map(Number)
    return new Date(Date.UTC(year, month - 1, day))
  }

  formatDate(date) {
    return [date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate()]
      .map((part, index) => index === 0 ? String(part) : String(part).padStart(2, "0"))
      .join("-")
  }
}
